// src/components/SubscriberLayout.js
import React from "react";
import { Outlet } from "react-router-dom";
import TopNav from "./TopNav";

/**
 * Shared layout for the subscriber-only pages (My Events, Connections,
 * Circles, Stay In Touch, Wishlist, Edit Profile). TopNav renders once here
 * instead of separately inside each page, so it stays mounted while
 * navigating between them - each page's own auth/data-loading spinner then
 * only replaces the content below the nav instead of the whole screen,
 * which previously made ordinary in-app navigation look like a full
 * browser reload (the header would vanish, then reappear once the new
 * page's fetch finished).
 */
const SubscriberLayout = () => (
  <>
    <TopNav />
    <Outlet />
  </>
);

export default SubscriberLayout;
